import { usePersistentFlag, usePersistentString } from "../app/persistentUi";

/**
 * Réglages carto du menu Paramètres (P2-42→45 + perso marqueur), persistés
 * navigateur. Défauts tous à ON. Lus ici et par la carte pilote (`PilotMap`).
 */
export const MAP_SETTING = {
  showDisconnected: "sentinelle.map.showDisconnected", // P2-42
  hideEmptyLines: "sentinelle.map.hideEmptyLines", // P2-43
  showShapes: "sentinelle.map.showShapes", // P2-44
  showStops: "sentinelle.map.showStops", // P2-45
  vehicleShape: "sentinelle.map.vehicleShape", // forme du marqueur véhicule
} as const;

/**
 * Forme du marqueur véhicule :
 *  - `arrow` : flèche de cap + pastille code ligne (défaut, historique) ;
 *  - `rocket` : rectangle avec une pointe orientée dans le sens de marche.
 */
export type VehicleShape = "arrow" | "rocket";

export interface MapSettings {
  showDisconnected: boolean;
  hideEmptyLines: boolean;
  showShapes: boolean;
  showStops: boolean;
  vehicleShape: VehicleShape;
}

export function useMapSettings(): MapSettings {
  const [showDisconnected] = usePersistentFlag(MAP_SETTING.showDisconnected, true);
  const [hideEmptyLines] = usePersistentFlag(MAP_SETTING.hideEmptyLines, true);
  const [showShapes] = usePersistentFlag(MAP_SETTING.showShapes, true);
  const [showStops] = usePersistentFlag(MAP_SETTING.showStops, true);
  const [vehicleShapeRaw] = usePersistentString(MAP_SETTING.vehicleShape);
  return {
    showDisconnected,
    hideEmptyLines,
    showShapes,
    showStops,
    vehicleShape: vehicleShapeRaw === "rocket" ? "rocket" : "arrow",
  };
}
